import { Pilot as ServerPilot, PilotOptions } from 'server/models/Pilot';

export { PilotOptions, PilotData } from 'server/models/Pilot';

export class Pilot extends ServerPilot {
    EffectiveCode() {
        return this.Code() || (
            this.User() ? this.User()!.FirstName()[0] + this.User()!.LastName()[0] : ''
        );
    }
}


// WEBPACK FOOTER //
// ./data/models/Pilot.ts